import TheGrid from '@/views/dealers/products/grid'
import Edit from '@/views/dealers/products/edit'

export default {
  path: '/dealers/products',
  redirect: '/dealers/products/index',
  name: 'dealerproducts',
  meta: {
    auth: {
      redirect: {
        name: 'dealerproducts.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Produtos Distribuidores'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'dealerproducts.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'dealerproducts.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'dealerproducts.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
